import { render, staticRenderFns } from "./todo-app.html?vue&type=template&id=3e9243c9&scoped=true&external"
import script from "./todo-app.js?vue&type=script&lang=js&external"
export * from "./todo-app.js?vue&type=script&lang=js&external"
import style0 from "./todo-app.scss?vue&type=style&index=0&id=3e9243c9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9243c9",
  null
  
)

export default component.exports